function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2000px",
    height: "2000px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#ff0420",
    d: "M 955.5,-0.5 C 984.833,-0.5 1014.17,-0.5 1043.5,-0.5C 1297.13,14.3576 1515.46,108.858 1698.5,283C 1883.65,468.39 1983.98,692.557 1999.5,955.5C 1999.5,984.833 1999.5,1014.17 1999.5,1043.5C 1984.64,1297.13 1890.14,1515.47 1716,1698.5C 1530.61,1883.65 1306.44,1983.98 1043.5,1999.5C 1014.17,1999.5 984.833,1999.5 955.5,1999.5C 701.867,1984.64 483.534,1890.14 300.5,1716C 115.562,1530.91 15.2291,1307.07 -0.5,1044.5C -0.5,1014.5 -0.5,984.5 -0.5,954.5C 15.2278,691.932 115.561,468.099 300.5,283C 483.534,108.86 701.867,14.3604 955.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffefe",
    d: "M 777.5,724.5 C 819.871,721.847 860.871,728.014 900.5,743C 957.775,766.276 991.275,808.442 1001,869.5C 1001.67,882.833 1001.67,896.167 1001,909.5C 993.154,963.399 982.487,1016.73 969,1069.5C 957.669,1111.83 938.669,1150.16 912,1184.5C 877.785,1223.64 834.952,1248.14 783.5,1258C 740.321,1265.39 696.988,1266.39 653.5,1261C 618.614,1255.05 586.947,1241.72 558.5,1221C 521.497,1189.38 503.83,1149.05 505.5,1100C 505.229,1088.41 506.063,1076.91 508,1065.5C 517.13,1012.99 528.463,960.986 542,909.5C 577.87,793.64 656.37,731.973 777.5,724.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffefe",
    d: "M 1299.5,1074.5 C 1264.48,1073.84 1229.82,1074.51 1195.5,1076.5C 1184.1,1132.24 1172.27,1187.9 1160,1243.5C 1156.82,1250.19 1151.65,1254.69 1144.5,1257C 1106.5,1257.67 1068.5,1257.67 1030.5,1257C 1025.9,1255.4 1023.07,1252.24 1022,1247.5C 1021.33,1243.5 1021.33,1239.5 1022,1235.5C 1056,1075.5 1090,915.496 1124,755.5C 1124.95,744.216 1130.78,736.716 1141.5,733C 1217.17,732.333 1292.83,732.333 1368.5,733C 1408.75,734.393 1446.09,745.393 1480.5,766C 1520.83,795.28 1537.66,834.78 1531,884.5C 1514.39,1003.77 1445.89,1066.94 1325.5,1074C 1316.84,1074.5 1308.17,1074.67 1299.5,1074.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff0620",
    d: "M 774.5,832.5 C 784.506,832.334 794.506,832.5 804.5,833C 839.232,836.066 858.399,854.899 862,889.5C 862.667,897.5 862.667,905.5 862,913.5C 853.627,969.323 841.627,1024.32 826,1078.5C 801.325,1139.93 756.158,1165.1 690.5,1154C 663.402,1145.55 648.902,1127.05 647,1098.5C 646.043,1085.41 646.71,1072.41 649,1059.5C 657.423,1013.05 667.756,967.05 680,921.5C 687.97,890.339 705.137,865.839 731.5,848C 745.063,840.316 759.396,835.149 774.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff0620",
    d: "M 1310.5,970.5 C 1279.5,970.5 1248.5,970.5 1217.5,970.5C 1217.5,969.167 1217.5,967.833 1217.5,966.5C 1226.18,923.453 1235.18,880.453 1244.5,837.5C 1277.49,836.333 1310.49,836.167 1343.5,837C 1354.91,837.361 1365.58,840.361 1375.5,846C 1384.45,853.407 1389.62,862.907 1391,874.5C 1392.92,904.1 1383.42,929.267 1362.5,950C 1347.4,962.423 1330.07,969.256 1310.5,970.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff6a79",
    d: "M 1217.5,966.5 C 1217.5,967.833 1217.5,969.167 1217.5,970.5C 1248.5,970.5 1279.5,970.5 1310.5,970.5C 1279.34,971.498 1248,971.832 1216.5,971.5C 1216.22,969.585 1216.55,967.919 1217.5,966.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff364d",
    d: "M 1299.5,1074.5 C 1264.93,1075.17 1230.26,1075.84 1195.5,1076.5C 1229.82,1074.51 1264.48,1073.84 1299.5,1074.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpIcon);
export default __webpack_public_path__ + "static/media/OP-icon.9379399fac471da207d887bcf387c6ac.svg";
export { ForwardRef as ReactComponent };